// Used to track events in Segment.
//
// For details of Segment's track call API see:
// https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#track

import { AnalyticsWindow } from "../window"

type EventProps = {
  event: string
  properties?: object
}

declare let window: AnalyticsWindow

export default function analyticsClickEvent(
  el: HTMLElement,
  props: EventProps,
) {
  el.addEventListener("click", () => {
    segmentTrackClickEvent(props)
  })
}

export function segmentTrackClickEvent(props: EventProps) {
  const properties = props.properties || {}
  const url = window.location.href
  const path = window.location.pathname
  const pageTitle = document.title
  const eventProperties = { ...properties, url, path, pageTitle }

  if (window.analytics) {
    window.analytics.track(props.event, eventProperties)
  }
}
